import React from "react"
import {SvgIcon} from "@mui/material"

export const ArrowRightIcon = (props) => (
    <SvgIcon {...props}>
        <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="black" strokeWidth="2" strokeLinecap="round"
              strokeLinejoin="round"/>
    </SvgIcon>
)